import { render, staticRenderFns } from "./AddCurriculumToDocumentDialog.vue?vue&type=template&id=bed680e2"
import script from "./AddCurriculumToDocumentDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddCurriculumToDocumentDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./AddCurriculumToDocumentDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports